export enum ProgressStatus {
  COMPLETED = 'COMPLETED',
  INPROGRESS = 'INPROGRESS',
  IDLE = 'IDLE',
}

export enum ProgressMode {
  AUTOMATED = 'AUTOMATED',
  MANUAL = 'MANUAL',
  // "Mark as finished" on a scheduled event: the training happened, but nothing
  // was logged in the app. Carries no performance data — the session totals
  // stay NULL (F3.2 plan; WorkoutSessionStats.mode has had this value since
  // the table was created, this is the writer for it).
  MARK_AS_DONE = 'MARK_AS_DONE',
}

// WorkoutProgressFeedback.mood — subjective descriptor, separate from effort
// (the 1.0-5.0 numeric rating / Peak Training Effect field).
export enum WorkoutFeedbackMood {
  BAD = 'bad',
  OK = 'ok',
  VERY_GOOD = 'very good',
  EXCELLENT = 'excellent',
}

// WorkoutProgressFeedback.completedWith — how the session was done, captured
// alongside the rest of the "Done Workout" feedback.
export enum WorkoutCompletionMode {
  SOLO = 'SOLO',
  WITH_TRAINER = 'WITH_TRAINER',
}
